module.exports = __webpack_public_path__ + "static/scale-model-of-winter-the-dolphin-in-clearwater-florida-e81e7abd12ef560088742f5c971fed64.png";